import { render } from "./MetaMaskInfo.vue?vue&type=template&id=1a12d2c7&scoped=true"
import script from "./MetaMaskInfo.vue?vue&type=script&lang=js"
export * from "./MetaMaskInfo.vue?vue&type=script&lang=js"

import "./MetaMaskInfo.vue?vue&type=style&index=0&id=1a12d2c7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a12d2c7"

export default script